import { commons, inheritorDocs, others } from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const HerdeiroLegalAtivoDocs = () => {
  const rules = {
    anexoOutros: dynamicRule(),
    anexoHerdeiro: dynamicRule('required'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoDeclaracaoHerdeiros: dynamicRule('required'),
  };

  const docs = {
    commons: [...commons, ...inheritorDocs, ...others],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
